module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('demonstration', {
    attrs: {
      "tag": "h2",
      "title": "Rate 评分",
      "show-content": false
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            评分组件 （"), _c('a', {
    attrs: {
      "href": "http://element.eleme.io/#/zh-CN/component/rate#rate-ping-fen",
      "target": "_blank"
    }
  }, [_vm._v("Element\n            Rate 评分")]), _vm._v("）\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "title": "基础用法",
      "anchor": "ji-chu-yong-fa",
      "highlight": _vm.sourcecodeA
    }
  }, [_c('template', {
    slot: "description"
  }, [_vm._v("\n            默认展示效果\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("默认不区分颜色")]), _vm._v(" "), _c('vm-rate', {
    model: {
      value: (_vm.valueA1),
      callback: function($$v) {
        _vm.valueA1 = $$v
      },
      expression: "valueA1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("区分颜色")]), _vm._v(" "), _c('vm-rate', {
    attrs: {
      "colors": _vm.colorsA2
    },
    model: {
      value: (_vm.valueA2),
      callback: function($$v) {
        _vm.valueA2 = $$v
      },
      expression: "valueA2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("指定大小，默认单位px")]), _vm._v(" "), _c('vm-rate', {
    attrs: {
      "size": 36
    },
    model: {
      value: (_vm.valueA3),
      callback: function($$v) {
        _vm.valueA3 = $$v
      },
      expression: "valueA3"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("指定大小，单位rem")]), _vm._v(" "), _c('vm-rate', {
    attrs: {
      "size": "2rem"
    },
    model: {
      value: (_vm.valueA4),
      callback: function($$v) {
        _vm.valueA4 = $$v
      },
      expression: "valueA4"
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            评分被分为三个等级，可以利用颜色对分数及情感倾向进行分级（默认情况下不区分颜色）。三个等级所对应的颜色用过 "), _c('code', [_vm._v("colors")]), _vm._v("属性设置，而它们对应的两个阈值则通过 "), _c('code', [_vm._v("low-threshold")]), _vm._v("\n            和 "), _c('code', [_vm._v("high-threshold")]), _vm._v(" 设定。"), _c('b', {
    staticClass: "new"
  }, [_vm._v("（"), _c('code', [_vm._v("low-threshold")]), _vm._v(" 和 "), _c('code', [_vm._v("high-threshold")]), _vm._v(" 作用于\n            "), _c('code', [_vm._v("colors")]), _vm._v(" 和 "), _c('code', [_vm._v("iconClasses")]), _vm._v("，用来显示不同的颜色和图标）")])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "anchor": "fu-zhu-wen-zi",
      "title": "辅助文字",
      "description": "用辅助文字直接地表达对应分数",
      "highlight": _vm.sourcecodeB,
      "multiple": true
    }
  }, [_c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("辅助文字数组")]), _vm._v(" "), _c('vm-rate', {
    attrs: {
      "show-text": "",
      "texts": ['极差', '失望', '一般', '满意', '惊喜']
    },
    model: {
      value: (_vm.valueB1),
      callback: function($$v) {
        _vm.valueB1 = $$v
      },
      expression: "valueB1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("辅助文字模板 "), _c('b', {
    staticClass: "new"
  }, [_vm._v("(新增特性，新增示例)")])]), _vm._v(" "), _c('vm-rate', {
    attrs: {
      "show-text": true,
      "text-type": "number",
      "text-template": "{value}星"
    },
    model: {
      value: (_vm.valueB2),
      callback: function($$v) {
        _vm.valueB2 = $$v
      },
      expression: "valueB2"
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            为组件设置 "), _c('code', [_vm._v("show-text")]), _vm._v(" 属性会在右侧显示辅助文字。通过设置 "), _c('code', [_vm._v("texts")]), _vm._v(" 可以为每一个分值指定对应的辅助文字。"), _c('code', [_vm._v("texts")]), _vm._v("\n            为一个数组，长度应等于最大值 "), _c('code', [_vm._v("max")]), _vm._v("。"), _c('b', {
    staticClass: "new"
  }, [_vm._v("（这里做了一些修改，如果你指定了 "), _c('code', [_vm._v("text-type=\"number\"")]), _vm._v(" 那么将会使用 "), _c('code', [_vm._v("text-template=\"{value}\"")]), _vm._v("\n            显示辅助文字）")])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "anchor": "qi-ta-icon",
      "title": "其它 icon",
      "description": "当有多层评价时，可以用不同类型的 icon 区分评分层级",
      "highlight": _vm.sourcecodeC
    }
  }, [_c('template', {
    slot: "source"
  }, [_c('vm-rate', {
    attrs: {
      "iconClasses": ['vm-icon-sad', 'vm-icon-neutral-full', 'vm-icon-smile'],
      "voidIconClass": "vm-icon-neutral-empty",
      "disabledVoidIconClass": "vm-icon-neutral-full",
      "colors": ['#99A9BF', '#F7BA2A', '#FF9900']
    },
    model: {
      value: (_vm.valueC1),
      callback: function($$v) {
        _vm.valueC1 = $$v
      },
      expression: "valueC1"
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            设置 "), _c('code', [_vm._v("icon-classes")]), _vm._v(" 属性可以自定义对应 3 个不同分段的图标。本例还使用 "), _c('code', [_vm._v("void-icon-class")]), _vm._v(" 指定了未选中时的图标类名。"), _c('b', {
    staticClass: "new"
  }, [_vm._v("（还使用了 "), _c('code', [_vm._v("disabledVoidIconClass")]), _vm._v("\n            指定了禁用时的图表类名）")])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "anchor": "zhi-du",
      "title": "只读",
      "description": "只读的评分用来展示分数，允许出现半星",
      "highlight": _vm.sourcecodeD,
      "multiple": true
    }
  }, [_c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("允许出现半星 "), _c('b', {
    staticClass: "new"
  }, [_vm._v("(修改特性)")])]), _vm._v(" "), _c('vm-rate', {
    attrs: {
      "disabled": "",
      "allow-half": true,
      "show-text": "",
      "text-color": "#ff9900",
      "text-template": "{value}"
    },
    model: {
      value: (_vm.valueD1),
      callback: function($$v) {
        _vm.valueD1 = $$v
      },
      expression: "valueD1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("不允许出现半星 "), _c('b', {
    staticClass: "new"
  }, [_vm._v("(新增示例)")])]), _vm._v(" "), _c('vm-rate', {
    attrs: {
      "disabled": "",
      "allow-half": false,
      "show-text": "",
      "text-color": "#ff9900",
      "text-template": "{value}❤"
    },
    model: {
      value: (_vm.valueD1),
      callback: function($$v) {
        _vm.valueD1 = $$v
      },
      expression: "valueD1"
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            为组件设置 "), _c('code', [_vm._v("disabled")]), _vm._v("\n            属性表示组件为只读，支持小数分值。此时若设置 "), _c('code', [_vm._v("show-text")]), _vm._v("，则会在右侧显示目前的分值。可以提供 "), _c('code', [_vm._v("text-template")]), _vm._v("\n            作为显示模板，模板为一个包含了 "), _c('code', [_vm._v("{value}")]), _vm._v("\n            的字符串，"), _c('code', [_vm._v("{value}")]), _vm._v(" 会被解析为分值。"), _c('b', {
    staticClass: "new"
  }, [_vm._v("（你可以通过 "), _c('code', [_vm._v("allow-half=\"true\"")]), _vm._v("来指定是否允许出现半星， 你也可以修改\n            "), _c('code', [_vm._v("text-template=\"{value}❤\"")]), _vm._v("的修饰文字）")])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "anchor": "ban-xing",
      "highlight": _vm.sourcecodeE,
      "multiple": true
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n            半星 "), _c('b', {
    staticClass: "new"
  }, [_vm._v("(新增示例)")])]), _vm._v(" "), _c('template', {
    slot: "description"
  }, [_vm._v("\n            当进行评价时，可以出现 .5 评分\n        ")]), _vm._v(" "), _c('template', {
    slot: "source"
  }, [_c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("默认半星")]), _vm._v(" "), _c('vm-rate', {
    attrs: {
      "allow-half": true
    },
    model: {
      value: (_vm.valueE1),
      callback: function($$v) {
        _vm.valueE1 = $$v
      },
      expression: "valueE1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("带辅助文字数组")]), _vm._v(" "), _c('vm-rate', {
    attrs: {
      "allow-half": true,
      "show-text": ""
    },
    model: {
      value: (_vm.valueE2),
      callback: function($$v) {
        _vm.valueE2 = $$v
      },
      expression: "valueE2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("带辅助文字模板")]), _vm._v(" "), _c('vm-rate', {
    attrs: {
      "allow-half": true,
      "show-text": "",
      "text-type": "number",
      "text-color": "#ff9900",
      "text-template": "{value}❤"
    },
    model: {
      value: (_vm.valueE3),
      callback: function($$v) {
        _vm.valueE3 = $$v
      },
      expression: "valueE3"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vd-demo__block vd-demo__block-1"
  }, [_c('span', {
    staticClass: "vd-demo__demonstration"
  }, [_vm._v("评分星星个数为10")]), _vm._v(" "), _c('vm-rate', {
    attrs: {
      "max": 10,
      "allow-half": true,
      "show-text": ""
    },
    model: {
      value: (_vm.valueE4),
      callback: function($$v) {
        _vm.valueE4 = $$v
      },
      expression: "valueE4"
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: "explanation"
  }, [_vm._v("\n            为组件设置 "), _c('code', [_vm._v("allow-half")]), _vm._v(" 属性表示组件为是否允许半星，支持小数分值。此时若设置 "), _c('code', [_vm._v("show-text")]), _vm._v("，则会在右侧显示目前的文字等级。也可以提供 "), _c('code', [_vm._v("text-type=\"number\"")]), _vm._v("\n            文字类型 和 "), _c('code', [_vm._v("text-template")]), _vm._v(" 作为显示模板，模板为一个包含了 "), _c('code', [_vm._v("{value}")]), _vm._v("\n            的字符串，"), _c('code', [_vm._v("{value}")]), _vm._v(" 会被解析为分值。为组件设置 "), _c('code', [_vm._v(":max=\"10\"")]), _vm._v("属性修改星星个数。\n        ")])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "anchor": "attributes",
      "title": "Attributes",
      "show-content": false
    }
  }, [_c('template', {
    slot: "table"
  }, [_c('table', {
    staticClass: "vd-demo__table"
  }, [_c('thead', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("可选值")]), _vm._v(" "), _c('th', [_vm._v("默认值")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("size "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增）")])]), _vm._v(" "), _c('td', [_vm._v("评分字体大小")]), _vm._v(" "), _c('td', [_vm._v("number / string")]), _vm._v(" "), _c('td', [_vm._v("% / in / cm / mm / em / ex / pt / pc / px / rem")]), _vm._v(" "), _c('td', [_vm._v("18")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("max")]), _vm._v(" "), _c('td', [_vm._v("最大分值")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("5")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled")]), _vm._v(" "), _c('td', [_vm._v("是否为只读")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("allow-half")]), _vm._v(" "), _c('td', [_vm._v("是否允许半选")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("low-threshold")]), _vm._v(" "), _c('td', [_vm._v("低分和中等分数的界限值，值本身被划分在低分中")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("2")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("high-threshold")]), _vm._v(" "), _c('td', [_vm._v("高分和中等分数的界限值，值本身被划分在高分中")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("4")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("colors")]), _vm._v(" "), _c('td', [_vm._v("icon 的颜色数组，共有 3 个元素，为 3 个分段所对应的颜色")]), _vm._v(" "), _c('td', [_vm._v("array")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("['#F7BA2A', '#F7BA2A', '#F7BA2A']")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("void-color")]), _vm._v(" "), _c('td', [_vm._v("未选中 icon 的颜色")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("#C6D1DE")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled-void-color")]), _vm._v(" "), _c('td', [_vm._v("只读时未选中 icon 的颜色")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("#EFF2F7")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("icon-classes")]), _vm._v(" "), _c('td', [_vm._v("icon 的类名数组，共有 3 个元素，为 3 个分段所对应的类名")]), _vm._v(" "), _c('td', [_vm._v("array")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("['vm-icon-star-on', 'vm-icon-star-on','vm-icon-star-on']")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("void-icon-class")]), _vm._v(" "), _c('td', [_vm._v("未选中 icon 的类名")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("vm-icon-star-empty")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("disabled-void-icon-class")]), _vm._v(" "), _c('td', [_vm._v("只读时未选中 icon 的类名")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("vm-icon-star-on")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-text")]), _vm._v(" "), _c('td', [_vm._v("是否显示辅助文字")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("false")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("text-color")]), _vm._v(" "), _c('td', [_vm._v("辅助文字的颜色")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("#1F2D3D")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("texts")]), _vm._v(" "), _c('td', [_vm._v("辅助文字数组")]), _vm._v(" "), _c('td', [_vm._v("array")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("['极差', '失望', '一般', '满意', '惊喜']")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("text-template")]), _vm._v(" "), _c('td', [_vm._v("只读时的辅助文字模板")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("{value}")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("text-type "), _c('i', {
    staticClass: "vd-demo__new"
  }, [_vm._v("（新增）")])]), _vm._v(" "), _c('td', [_vm._v("辅助文字类型")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_vm._v("number")]), _vm._v(" "), _c('td', [_vm._v("text")])])])])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "anchor": "event",
      "title": "Events",
      "show-content": false
    }
  }, [_c('template', {
    slot: "table"
  }, [_c('table', {
    staticClass: "vd-demo__table"
  }, [_c('thead', [_c('th', [_vm._v("事件名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("change")]), _vm._v(" "), _c('td', [_vm._v("分值改变时触发")]), _vm._v(" "), _c('td', [_vm._v("改变后的分值")])])])])])], 2), _vm._v(" "), _c('demonstration', {
    attrs: {
      "show-content": false
    }
  }, [_c('p', [_vm._v("示例使用详情请参考：（"), _c('a', {
    attrs: {
      "href": "https://github.com/savoygu/vue-demonstration"
    }
  }, [_vm._v("https://github.com/savoygu/vue-demonstration")]), _vm._v("）\n        ")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-07ed77e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-07ed77e0","hasScoped":false}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./example/src/App.vue
// module id = 8
// module chunks = 0